import React from "react";

import HeroSlider from "../components/UI/HeroSlider";
import Helmet from "../components/Helmet/Helmet";

import { Container, Row, Col } from "reactstrap";
import ProjectInquiryForm from "../components/UI/ProjectInquiryForm";
import AboutSection from "../components/UI/AboutSection";
import ServicesList from "../components/UI/ServicesList";
import carData from "../assets/data/carData";
import CarItem from "../components/UI/CarItem";
import BecomeDriverSection from "../components/UI/BecomeDriverSection";
import Testimonial from "../components/UI/Testimonial";

import BlogList from "../components/UI/BlogList";
import EquipmentList from "../components/UI/CarItem";
import ProjectsSection from "../components/UI/Project";

const Home = () => {
  return (
    <Helmet title="Home">
      {/* ============= hero section ===========hero__slider-section */}
      {/* <section className="p-0 "> */}
      <HeroSlider />

      {/* </section> */}
      {/* =========== about section ================ */}
      <AboutSection />
      {/* ========== services section ============ */}
      <ServicesList />

      <EquipmentList />

      <ProjectsSection />

      {/* <Testimonial /> */}
    </Helmet>
  );
};

export default Home;
